module.exports = __webpack_public_path__ + "img/avatar2.e74d45db.png";